export const LEADS_MODAL_STEPS = {
    SETUP: 'setup',
    PREVIEW: 'preview',
    ENRICHING: 'enriching',
    REVIEW: 'review',
    COMPLETE: 'complete',
};

export const RESULT_BUCKETS = {
    NEW: 'new',
    DUPLICATES: 'duplicates',
};

export const CATEGORY_OPTIONS = [
    { value: 'Retail', labelKey: 'businessTypeRetail' },
    { value: 'Healthcare', labelKey: 'businessTypeHealthcare' },
    { value: 'Manufacturing', labelKey: 'businessTypeManufacturing' },
    { value: 'Professional services', labelKey: 'businessTypeProfessional' },
    { value: 'Food & beverage', labelKey: 'businessTypeFood' },
    { value: 'HVAC & facilities', labelKey: 'businessTypeHvac' },
    { value: '', labelKey: 'anyBusinessType' },
];

export const MAX_RESULT_OPTIONS = [
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
];

export const RADIUS_OPTIONS = [
    { value: '1', label: '1 km' },
    { value: '2', label: '2 km' },
    { value: '5', label: '5 km' },
    { value: '10', label: '10 km' },
];

export const DEFAULT_CREDIT_BALANCE = 50;

/** EntityListSelect + NewEntityList / DataGrid key for the leads preview table */
export const LEADS_PREVIEW_ENTITY = {
    entity: 'leadsPreview',
    trueName: 'leadsPreview',
};

/** Column `colId` used for row checkboxes (must match `LeadList` column def) */
export const LEADS_PREVIEW_CHECKBOX_COL_ID = 'lead';
